import { StoredConversation } from "../lib/conversations";

interface ConversationSidebarProps {
  conversations: StoredConversation[];
  activeThreadId?: string;
  onSelect: (threadId: string) => void;
  onDelete: (threadId: string) => void;
  onNew: () => void;
}

// 纯本地的会话历史列表（数据来自 localStorage，见 lib/conversations.ts）；
// 不请求服务端，刷新页面/换设备不会同步，这是有意为之的简单方案。
export default function ConversationSidebar({
  conversations,
  activeThreadId,
  onSelect,
  onDelete,
  onNew,
}: ConversationSidebarProps) {
  return (
    <aside className="flex w-60 shrink-0 flex-col border-r border-slate-200 bg-slate-50">
      <div className="p-3">
        <button
          onClick={onNew}
          className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
        >
          + 新建对话
        </button>
      </div>

      <div className="flex-1 space-y-1 overflow-y-auto px-2 pb-3">
        {conversations.length === 0 ? (
          <p className="px-2 py-4 text-center text-xs text-slate-400">暂无历史对话</p>
        ) : (
          conversations.map((c) => (
            <div
              key={c.threadId}
              onClick={() => onSelect(c.threadId)}
              className={`group flex cursor-pointer items-start justify-between gap-1 rounded-lg px-2.5 py-2 text-left transition ${
                c.threadId === activeThreadId ? "bg-slate-200" : "hover:bg-slate-100"
              }`}
            >
              <div className="min-w-0 flex-1">
                <p className="truncate text-xs font-medium text-slate-700">{c.title}</p>
                <p className="mt-0.5 flex items-center gap-1 text-[11px] text-slate-400">
                  <span className="truncate">{c.env}</span>
                  <span>·</span>
                  <span>{formatRelativeTime(c.updatedAt)}</span>
                </p>
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(c.threadId);
                }}
                className="shrink-0 rounded px-1 text-xs text-slate-300 opacity-0 hover:bg-slate-300 hover:text-slate-600 group-hover:opacity-100"
                aria-label="删除对话"
              >
                ✕
              </button>
            </div>
          ))
        )}
      </div>
    </aside>
  );
}

function formatRelativeTime(ts: number): string {
  const diffMs = Date.now() - ts;
  const min = Math.floor(diffMs / 60000);
  if (min < 1) return "刚刚";
  if (min < 60) return `${min} 分钟前`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} 小时前`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day} 天前`;
  return new Date(ts).toLocaleDateString();
}
